import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { INGREDIENT_NODE_FRAGMENT } from '../fragments'

const SAVE_INGREDIENTS_MUTATION = gql`
  mutation saveIngredients($data: [IngredientNodeInput!]!) {
    saveIngredients(data: $data) {
      results {
        ...IngredientNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${INGREDIENT_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default SAVE_INGREDIENTS_MUTATION
